import { z } from 'zod'

import type { Character } from '@/features/studio-renew/types'

const habitsSchema = z.array(
  z.looseObject({ id: z.unknown().optional(), text: z.string() })
)
const validId = (value: unknown): value is string =>
  typeof value === 'string' && !!value.trim()

/** 말버릇 ID는 편집 행의 키다. 서버는 text만 요구하므로 읽을 때 누락·중복 ID를 보완한다. */
export function normalizeHabitIds(
  characterId: string,
  value: unknown
): Character['habits'] {
  const rows = habitsSchema.parse(value ?? [])
  const reserved = new Set(
    rows.flatMap((row) => (validId(row.id) ? [row.id] : []))
  )
  const used = new Set<string>()
  let changed = false
  const normalized = rows.map((row, index) => {
    let id = validId(row.id) ? row.id : ''
    if (!id || used.has(id)) {
      const base = `habit-${characterId}-${index}`
      id = base
      let suffix = 1
      while (reserved.has(id) || used.has(id)) id = `${base}-${suffix++}`
      changed = true
    }
    used.add(id)
    return { ...row, id }
  })
  // 같은 저장본은 같은 키를 쓰고, 이미 정상인 행·배열의 참조도 유지한다.
  return changed || !Array.isArray(value)
    ? normalized
    : (value as Character['habits'])
}
